export const resources = {
  superAdmin: { userTitle: 'Admin' },
  restaurant: {
    outletCode: 'Outlet Code',
    subscriptionDaysLeftSuffix: 'days left',
    subscriptionExpiredText: 'Expired',
    trialDaysLeftBannerMessage: 'You have {trialRemainingDays} days left on your trial',
    trialExpirationBannerMessage:
      'Your trial of {lastActivePlanName} plan has expired and you’ve been moved to {currentActivePlanName} plan',
    planDaysLeftBannerMessage:
      'You have {planRemainingDays} days left on your active subscription plan',
    planExpirationBannerMessage:
      'Your subscription of {lastActivePlanName} plan has expired and you’ve been moved to {currentActivePlanName} plan',
    subscribeCTAText: 'SUBSCRIBE',
    upgradeNowCTAText: 'UPGRADE NOW',
    planExpiryReminderOverlayTitle: 'Reminder',
    planExpiredOverlayTitle: 'Attention!',
    saasPlansPopup: {
      title: 'Subscription Plans',
      subscribeCTA: 'SUBSCRIBE',
      currentPlanCTA: 'CURRENT PLAN',
      upgradeCTA: 'UPGRADE',
      downgradeCTA: 'DOWNGRADE',
      subscribedToPrefix: 'Subscribed to',
      validTillPrefix: 'Valid till',
      trialEndsPrefix: 'Trial ends in',
      daysSuffix: 'days',
      requestedFeatureUnavailableMessage:
        'Requested feature is not included in your current plan. Upgrade to avail this feature.',
      exclusiveFeatureLabel: 'Just for you',
    },
    subscriptionRequestPopup: {
      title: 'Request Raised',
      requestRaisedMessage:
        'We have received your request to subscribe to Fudr {planName} plan. Our team will get back to you with further details.',
      actionBtn: 'OK',
    },
    subscriptionRequestAlreadyRaisedPopup: {
      title: 'Request Already Raised',
      requestAlreadyRaisedMessage:
        'We have already received your request to subscribe to Fudr {planName} plan. Our team will get back to you soon.',
      actionBtn: 'OK',
    },
    goLiveRestaurantPopup: {
      title: 'Checklist to Go live',
      description: `Please make sure to complete the below checklist 
      before going live.`,
      successTitle: 'Your Outlet is Live ',
      successDescription: `Your guests can now view your menu 
      and place orders digitally`,
      actionCTA: 'GO LIVE NOW',
      cancelCTA: 'BACK',
      okCTA: 'OK',
      setupMenuText: 'See how to <a>setup your menu</a> in few easy steps',
      qrCodeSetupText: `(applicable for Dine-in restaurants & 
        In room dining hotels)`,
      menuSetupInfoBox: {
        title: 'Menu Pending',
        informationText: 'You need to add menu items to Go Live. ',
        actionBtn: 'SETUP MENU',
      },
      errorMessage: 'Please complete the following checklist',
    },
  },
  menu: {
    customization: {
      customizations: 'Customizations',
      addCustomizationCTA: 'ADD GROUP',
      emptyCustomizedItemsPlaceholder: 'No items in this group',
      emptyCustomizationGroupItemPlaceholder: 'Please add the customization group to add the items',
      emptyCustomizationGroupPlaceholder: 'No customization group added',
      itemDetailHeading: 'Details',
      applicableOnText: 'Applied on',
      noApplicableItemText: 'Not applied on any item',
      zeroPriceLabel: 'No extra cost',
      createCustomizedItemToastMessage: 'Customized item created successfully',
      createCustomizedGroupToastMessage: 'Customized group created successfully',
      deleteCustomizedItemToastMessage: 'Customized item deleted successfully',
      deleteCustomizationGroup: 'Delete Group',
      editCustomizationGroup: 'Edit Group',
      deleteCustomizationItem: 'Delete Item',
      editCustomizationItem: 'Edit Item',
      popupType: {
        customizedGroup: 'Group',
        customizedItem: 'Item',
      },
      toastMessage: {
        createCustomizedItem: 'Customization item created successfully',
        createCustomizedGroup: 'Customization group created successfully',
        editCustomizedGroup: 'Customization group updated successfully',
        editCustomizedItem: 'Customization item updated successfully',
        deleteCustomizedItem: 'Customization item deleted successfully',
        deleteCustomizedGroup: 'Customization group deleted successfully',
      },
      deleteCustomizedItem: {
        title: 'Delete Customization',
        description:
          'Are you sure you want to delete this customization? It will not be available on the menu items it has been applied on.',
        backBtn: 'CANCEL',
        actionBtn: 'DELETE',
      },
      deleteCustomizedGroup: {
        title: 'Delete Group',
        description:
          'Are you sure you want to delete this customization group? All the customization in this group will be deleted as well',
        backBtn: 'CANCEL',
        actionBtn: 'DELETE',
      },
      customizedItemDetails: {
        title: 'Add Item',
        editItem: 'Edit Item',
        cancelCTA: 'CANCEL',
        updateCTA: 'UPDATE',
        addCTA: 'ADD',
        label: {
          itemName: 'Item Name',
          itemType: 'Type',
          itemDescription: 'Description',
          itemPrice: 'Price',
          tax: 'Tax@',
        },
        placeholder: {
          itemName: 'Enter customization item name',
          itemDescription: 'Enter customization description (optional)',
        },
        errorInfo: {
          MENU_CUSTOMIZATION_NAME_EXISTS: {
            message: 'This name already exist. Please use another name.',
          },
        },
        errorMessage: {
          title: 'Please enter a valid item title',
          description: 'Char limit excceds 100',
          price: 'Please enter a valid price',
          general: 'Please resolve highlighted issues',
        },
        taxRateNote:
          'Generally, GST of customizations is same as menu but in some cases, it is different. {br}{br}Mostly in alcohol drinks, where Menu item (eg. Whiskey) have 24% GST and Add-on (eg. Colddrink) have 5% GST',
        taxInclusiveLabel:
          'Price is inclusive of taxes.\n Tax rate is required for billing purpose only.',
        taxExclusiveLabel: 'Price is exclusive of taxes.\n Tax will be added to the final price.',
      },
      customizedGroupDetails: {
        title: 'Add New Group',
        editTitle: 'Edit Group',
        cancelCTA: 'CANCEL',
        updateCTA: 'UPDATE',
        addCTA: 'ADD',
        groupTitleText: 'Group Title',
        sectionTypeText: 'Selection Type',
        selectionTypes: {
          singleSelect: {
            title: 'Single Select',
            description: 'Guest will be able to select only one customization item of this group',
          },
          multiSelect: {
            title: 'Multi Select',
            description: 'Guest will be able to select multiple customization items of this group',
          },
        },
        placeHolder: {
          groupTitle: 'Enter group title',
        },
        errorMessage: {
          title: 'Please enter a valid group title',
          general: 'Please resolve the highlighted issue',
        },
        errorInfo: {
          DUPLICATE_NAME: {
            message: 'This name already exist. Please use another name.',
          },
        },
      },
    },
  },
  setting: {
    additionalServiceCharges: {
      packingChargeTitle: 'Packing Charge',
      serviceChargeTitle: 'Service Charge',
      additionalChargesTitle: 'Additional Charge',
    },
    orderModeTitlePopup: {
      popupContent: {
        title: 'Edit Title',
        actionBtn: 'UPDATE',
        backBtn: 'BACK',
        footerAddOn: 'USE DEFAULT',
      },
      description: 'Order Mode : {orderModeTitle}',
      placeHolder: {
        enterTitle: 'Enter Title',
      },
      updateToastMessage: 'Order mode title updated',
      errorMessage: {
        invalidOrderModeTitle: 'Please enter valid order mode title',
        genericErrorText: 'Please resolve the highlighted issues',
      },
    },
    deliveryLocationSettings: {
      outletAddressText: 'Outlet Address',
      deliveryAreaText: 'Delivery Area',
      deliveryDistanceText: 'Delivery distance',
      informationBox: {
        title: 'New Feature',
        actionBtn: 'Try Now',
        informationText:
          'Distance based delivery area - Define how far you are willing to deliver. Select delivery area on Google map.',
      },
      restaurantDeliveryErrorBox: {
        title: 'Delivery mode not enabled',
        informationText:
          'Delivery mode needs to be enabled to select delivery location. Please select Delivery in Orders modes. ',
      },
      restaurantDeliveryWarningBox: {
        title: 'Delivery Orders Paused',
        actionBtn: 'RESUME',
      },
      selectDeliveryLocationPopup: {
        title: 'Delivery Area',
        sectionTitle: {
          restaurantLocation: 'Location',
          deliveryArea: 'Delivery Area',
        },
        label: { location: 'Outlet Address' },
        deliveryArea: {
          acrossCity: { title: 'Delivery across city' },
          googleMapCircle: { title: 'Distance based', description: 'Define the delivery distance' },
          customLocation: {
            title: 'Custom locations',
            description: `Manually define delivery locations (not on google maps). Guest will be able to select
          only from the defined locations. Suited for hyperlocal deliveries.`,
          },
        },
        warningBox: {
          title: 'Outlet address and location seems to be too far',
          actionBtn: 'RESET',
        },
        errorMessage: 'Please resolve the highlighted issues',
        errorInfo: {
          invalidDeliveryRange: 'Invalid range',
          emptyOutletAddress: 'Please provide outlet address',
        },
        footerContent: {
          backBtn: 'CANCEL',
          actionBtn: 'SAVE',
          updateBtn: 'UPDATE',
        },
      },
    },
  },
  upsell: {
    actionBtn: 'START UPSELLING',
    upsoldedItemText: 'Upsell Items',
    upsoldAmountText: 'Upsold Amount',
    editDiscountCTA: 'Edit Discount',
    removeItemCTA: 'Remove Item',
    manageItemsCTA: 'Manage Items',
    upsellToastMessage: 'Upsell menu item updated successfully',
    pauseUpsellToastMessage: 'Upsell paused successfully',
    resumeUpsellToastMessage: 'Upsell resumed successfully',
    premium: 'Premium',
    pauseTagText: 'Upsell Stopped',
    pauseTagTooltipContent: 'Items will not be suggested to guests on the cart page',
    pauseCTABtn: 'STOP UPSELL',
    resumeCTABtn: 'RESUME UPSELL',
    upsellInitialisationDetailsTitle: 'Increase your Sales by upselling !!!',
    upsellInitialisationDetails: [
      {
        title: 'Gamified Upselling ',
        description: 'Suggest items on cart page in a gamified way.',
      },
      {
        title: 'Dynamic Discount',
        description: `Offer discount based on the Cart value. More the cart 
          value, more the discount on item`,
      },
    ],
    resumeUpsellPopup: {
      title: 'Resume Upsell',
      description:
        'Are you sure you want to resume upsell? Items will be suggested to guests on the cart page.',
      backBtn: 'BACK',
      actionBtn: 'RESUME',
    },
    removeUpsellPopup: {
      title: 'Remove item from Upsell',
      description:
        'Are you sure you do not want to upsell this item? This item will not be suggested to guests on the cart page.',
      backBtn: 'BACK',
      actionBtn: 'REMOVE',
    },
    disableItemTooltip: {
      title: 'Item Disabled',
      description:
        'Disabled items are not part of Upsell. This item will not be suggested on cart page.',
      subDescription: 'To enable this item, go to Menu Section',
    },
    pauseUpsellPopup: {
      title: 'Stop Upsell',
      backBtn: 'BACK',
      actionBtn: 'STOP UPSELL',
      placeholder: 'Type ',
      description: [
        'Are you sure you want to stop upsell?',
        'Items will not be suggested to guests on the cart page',
        ' ',
        'To Stop Upsell,',
        'type {stopText} in the below textbox.',
      ],
      instruction: {
        instructionOne: `Are you sure you want to stop upsell?
        Items will not be suggested to guests on the cart page`,
        instructionTwo: `To Stop Upsell,
        type <b>{stopText}</b> in the below textbox.`,
      },
    },
    upsellPopup: {
      title: 'Upsell',
      selectItemText: 'Select items to upsell',
      dynamicDiscountTitle: 'Dynamic Discount Limit',
      dynamicDiscountDescription: `Discounts are offered dynamically based on the cart value.
        Select the discount range`,
      minimumCartValueTitle: 'Minimum Cart Value',
      minimumCartValueDescription:
        'Define the minimum cart vale on which the guest can avail upsell items at a discounted price ',
      howItWorksTitle: 'How it works',
      howItWorksDescription:
        'When the cart value is more than Minimum cart value, guests are suggested upsell items in an exciting gamified way. Three menu items are presented to the guest having a discount whithin the selected Dynamic discount limit. For eg. if 5%-75% is selected, Veg. Manchurian might be shown at 10% off to a guests and 50% off to another.',
      searchFieldPlaceholder: 'Search by Item Name',
      searchCTABtnText: 'SEARCH',
      showOnlySelectedText: 'Show only selected',
      nextBtn: 'NEXT',
      backBtn: 'CANCEL',
      updateBtn: 'UPDATE',
      actionBtn: 'START UPSELL',
      popularTag: 'POPULAR',
      errorMessage: 'Please resolve the highlighted issues',
      customDiscountErrorMessage: 'Invalid discount range',
      noUpsellItemSelectedErrorMessage: 'Please select at least one item to proceed',
      minCartValueRangeErrorMessage: 'Please enter an amount between 1 to 99999',
      upselledItemCountText: 'upsell items have customised Discount Range',
      upselledDiscountText: 'Select items to update Discount Range to',
      upsellPriceText: 'Upsell Price',
      itemName: 'Item Name',
      itemPrice: 'Item Price',
      category: 'Category',
      price: 'Price',
      discountRange: 'Discount Range',
      disableItemTooltip: {
        title: 'Item Disabled',
        description:
          'Disabled items are not part of Upsell. This item will not be suggested on cart page.',
        subDescription: 'To enable this item, go to Menu Section',
      },
      selectedSuffix: 'selected',
    },
  },
  offer: {
    popup: {
      title: 'New Offer',
      footer: {
        newOffer: {
          backBtn: 'CANCEL',
          backCTA: 'BACK',
          actionBtn: 'PROCEED',
        },
        edit: {
          backBtn: 'CANCEL',
          actionBtn: 'UPDATE',
        },
        confirmation: {
          backBtn: 'NO',
          message: 'Are you sure you do not want to create this offer?',
          actionBtn: 'YES',
        },
        editConfirmation: {
          backBtn: 'NO',
          message: 'Are you sure you do not want to update this offer?',
          actionBtn: 'YES',
        },
        create: {
          backBtn: 'CANCEL',
          backCTA: 'BACK',
          actionBtn: 'CREATE',
        },
      },
    },
  },
  orderTransactionDetails: {
    orderId: 'Order ID',
    orderStatus: 'Order Status',
    paymentDetails: {
      title: 'Payment Details',
      amount: 'Amount',
      paymentMode: 'Payment Mode',
      transactionOn: 'Transaction on',
      pointsDebited: 'Points Debited',
      referenceId: 'Reference ID',
      paymentStatus: {
        label: 'Payment Status',
        pending: 'Pending',
        successful: 'Successful',
        remark: 'Remark',
      },
    },
    refundDetails: {
      title: 'Refund Details',
      refundAmount: 'Refund Amount',
      pointsCredited: 'Points Credited',
      referenceId: 'Reference ID',
      acquirerReferenceNumber: 'ARN (Acquirer Reference Number)',
      refundMode: {
        label: 'Refund Mode',
        cashCard: 'Cash Card',
        prepaid: 'Source',
      },
      refundStatus: {
        label: 'Refund Status',
        processed: 'Processed',
        initiated: 'Initiated',
        failed: 'Failed',
        remark: 'Remark',
      },
      initiatedOn: 'Initiated on',
      processedOn: 'Processed on',
    },
    fudrPaid: 'Fudr Paid',
    payToRestaurant: 'Pay to Restaurant',
    cashCard: 'Cash Card',
    userDroppedStatus: 'User Dropped',
    invalidTxnStatus: 'Invalid Transaction',
  },
  cashCard: {
    title: 'Cash Card',
    premium: 'Premium',
    pauseTagText: 'Cash Card Stopped',
    editCashCardCTA: 'Edit Cash Card',
    resumeCashCardCTA: 'Resume Cash Card',
    stopCashCardCTA: 'Stop Cash Card',
    pauseCashCardTooltipText:
      'Guests will not be able to recharge card but can pay from existing cash card points',
    cashCardInitialisationDetailsTitle: `Create your Outlet’s Cash Card and 
      provide extra convenience to your Guests`,
    cashCardInitialisationDetails: [
      'Your guests can upload cash in your Cash Card and do payments with a single click',
      'Know which guests are using the Cash Card and provide them extra benefits.',
    ],
    popup: {
      ADD: {
        title: 'Create Cash Card',
        backBtn: 'CANCEL',
        actionBtn: 'CREATE',
        changeLogoCTA: 'CHANGE LOGO',
        changeLogoText: 'Change Logo',
        changeLogoTooltip: `Recomemded size - 360px X 200px
        Supported format - JPG , PNG
        Maximum file size - 5MB`,
        cardName: 'Card Name',
        cardNameDescription: 'Please define the name of your Card',
        minimumAmount: 'Minimum Amount',
        minimumAmountDescription: 'Please define the minimum amount to be added in the Card',
        placeholder: {
          cardName: 'Please enter card name',
          minAmount: 'Enter value',
        },
        fieldsErrorMessage: {
          emptyCardName: 'Please provide card name',
          cardNameLimitExceed: 'Card name should be less than {maxCharLimit} character',
          emptyMinAmount: 'Please provide minimum amount',
          negativeMinAmount: 'Please provide a valid amount',
          minAmountLimitExceed: 'Minimum amount should be less than or equal to {minAmountLimit}',
        },
        genericErrorMessage: 'Resolve the highlighted issues to proceed ',
        cardColorSectionTitle: 'Card colour',
        blendLogoBackgroundToggleText: 'Remove Logo Background',
        blendLogoBackgroundToggleDescription:
          'This will remove white background in the Logo’s image',
      },
      EDIT: {
        title: 'Edit Cash Card',
        updateBtn: 'UPDATE',
      },
      changeLogoDropdownItem: {
        uploadNew: 'Upload New',
        useDefault: 'Use Default',
      },
      backBtn: 'BACK',
      UploadBtn: 'UPLOAD',
      accessRestricted: {
        title: 'Access Restricted',
        description: `You do not have access to change cash card details.
        Please login with  "{adminRestaurantName}"  account to edit cash card details.`,
        actionBtn: 'OK',
      },
      resumeCashCard: {
        title: 'Resume Cash Card',
        description:
          'Are you sure you want to Resume your Cash Card ? Guests will be able to add money in their Cash Cards',
        actionBtn: 'RESUME',
        backBtn: 'BACK',
      },
      stopCashCard: {
        title: 'Stop Cash Card',
        backBtn: 'BACK',
        actionBtn: 'STOP CASH CARD',
        stopInstruction: 'Type ',
        activeOutletListHeading: 'Currently active on following outlets',
        description: {
          warningMessage: `Are you sure you want to Stop your Cash Card?
          Guests will not be able to add money but will be able to
          pay from the existing cash card amount.`,
          stopCashCardInstructions: `<span>To stop cash card,
          type <b>{stopText}</b> in the below textbox.</span>`,
        },
      },
      cashCardRecharge: {
        warning: {
          title: 'Recharge',
          description: 'Your cash card is currently stopped. Please resume the same to recharge.',
          actionBtn: 'DONE',
        },
        title: 'Recharge',
        sendOtpMessage: 'PIN will be sent on {guestMobileNo} to verify mobile no',
        guestDetails: 'Guest Details',
        allFieldsAreMandatoryText: '( All fields are mandatory )',
        rechargeAmount: 'Recharge Amount',
        rechargeCompleted: 'Recharge completed',
        addedInCart: 'Added in Card',
        noGuestFoundText: 'No Guest Found for {newGuestPhoneNumber}',
        footerContent: {
          backBtn: 'CANCEL',
          actionBtn: 'RECHARGE',
        },
        rechargeCompletedFooterContent: {
          actionBtn: 'DONE',
        },
        CTA: {
          addGuest: 'ADD GUEST',
          search: 'SEARCH',
        },
        label: {
          guestMobileNo: 'Guest Mobile No.',
          guestName: 'Name',
          guestEmail: 'Email',
          verificationPin: 'Verification PIN',
          amount: 'Amount',
          confirmAmount: 'Confirm Amount',
          last30DaysSpend: 'Last 30 days spend',
          lastVisit: 'Last visit',
          totlOrders: 'Total Orders',
          usingFudrSince: 'Using Fudr since',
          previousRechargeAmount: 'Previous Recharge Amount',
          cashCardIssuedOn: 'Cash Card Issued on',
          ordersWithCashCard: 'Orders with Cash Card',
          viewMoreDetails: 'View more details',
          mobileNumber: 'Mobile Number',
        },
        placeHolder: {
          guestMobileNo: 'Enter Mobile no.',
          guestName: 'Enter Guest Name',
          guestEmail: 'Enter Guest Email id',
          pin: 'Enter PIN sent on guest mobile no.',
          searchGuestByMobileNumber: 'Search guest by mobile no.',
          amount: 'Enter Amount',
          confirmAmount: 'Enter amount again',
        },
        description: {
          name: 'Points will reflect in account with the provided mobile no.',
          email: 'Cash card transactions will be shared on provided email id',
          pinSent: 'PIN sent on {phoneNumber}',
          pointsCredited: '{amount} will be credited',
          pinVerification: 'PIN will be sent to {newGuestPhoneNumber} for verification',
        },
        errorMessage: {
          genericErrorText: 'Please resolve the highlighted issues',
          invalidPhoneNumber: 'Please enter a valid mobile number',
          invalidName: 'Please enter correct guest name',
          invalidEmailAddress: 'Please enter a valid email address',
          invalidAmount: 'Please enter a valid amount',
          amountMismatch: 'Amount did not match',
          invalidOtp: 'Please enter valid PIN',
          searchGuest: 'Please click on search to view details',
          minRechargeAmount: 'Min. recharge amount is',
          maxRechargeAmount: 'Max. recharge amount is',
        },
        errorInfo: {
          msgServiceTimeoutError: {
            message: 'Something went wrong while generating the PIN. Please try again.',
          },
        },
      },
      guestCashCardTransactionDetails: {
        title: 'Transaction Details',
        actionBtn: 'OK',
        transactionTypeText: {
          add: 'Added in Card',
          refund: 'Refunded in Card',
          reward: 'Rewarded in Card',
          payment: 'Paid',
          expired: 'Expired',
        },
        secondaryDetailTitles: {
          amount: 'Amount',
          orderNumber: 'Order ID',
          status: 'Transaction Status',
          id: 'Reference ID',
          transactionDate: 'Transaction Date',
          outlet: 'Outlet',
        },
      },
    },
    toastMessage: {
      createCashCard: 'Cash Card created ',
      updateCashCard: 'Cash Card updated',
    },
    cashCardPreview: {
      cardNameSuffix: 'Card',
      balanceLabel: 'Balance',
    },
    cashCardDetails: {
      title: 'Card Details',
      yourCashCardPreviewText: 'Your Cash Card Preview',
      label: {
        cardName: 'Card Name',
        minRechargeAmount: 'Minimum Recharge Amount',
      },
    },
    cashCardUsage: {
      title: 'Card Usage',
      cardUsageDetail: 'Card Usage Details',
      columns: {
        dateTime: 'Date & Time',
        guest: 'Guest',
        type: 'Type',
        outlet: 'Outlet',
        details: 'Details',
        status: 'Status',
        points: 'Points',
      },
      search: {
        placeHolder: 'Search by Guest Name, Phone No.',
        CTA: 'SEARCH',
      },
    },
    CTA: {
      createCashCard: 'CREATE CASH CARD',
      recharge: 'RECHARGE',
      viewDetails: 'VIEW DETAILS',
      resumeCashCard: 'RESUME',
      stopCashCard: 'STOP',
      cardUsageViewDetails: 'View Details',
    },
    cardStatistics: {
      totalRechargeAmount: 'Total Recharge Amount',
      totalCashCardIssued: 'Total Cash Cards issued',
    },
    cardList: {
      title: 'Issued Cards',
      search: {
        placeHolder: 'Search by Guest Name, Phone No.',
        CTA: 'SEARCH',
      },
      cardDetails: 'Card Details',
      columns: {
        guestName: 'Guest Name',
        phoneNumber: 'Phone No.',
        lastUsed: 'Last Used',
        issuedOn: 'Issued On',
        totalRecharge: 'Total Recharge',
        balance: 'Balance',
      },
      appliedFilterText: 'Filter(s) applied',
    },
    cardDetails: {
      columns: {
        dateTime: 'Date & Time',
        type: 'Type',
        details: 'Details',
        status: 'Status',
        points: 'Points',
        outlet: 'Outlet',
      },
      label: {
        totalAmountAdded: 'Total Amount Added',
        balance: 'Balance',
        cashCardIssuedOn: 'Cash Card Issued on',
        ordersWithCashCard: 'Orders with Cash Card',
        last30DaysSpend: 'Last 30 days Spend',
        previousRechargeAmount: 'Previous Recharge Amount',
      },
      transactionDetailText: {
        cash: 'Cash',
        empty: '-',
        online: 'Online',
      },
    },
    cashCardTransactionFilter: {
      amountText: 'Amount',
      statusText: 'Status',
      typeText: 'Type',
      categoryText: 'Category',
      dateText: 'Date',
      minAmountText: 'Min',
      maxAmountText: 'Max',
      outletText: 'Outlet',
    },
    issuedCashCardFilter: {
      lastUsedText: 'Last used',
      issuedOnText: 'Issued on',
      statusText: 'Status',
      balanceText: 'Balance',
      rechargeText: 'Recharge',
      spendText: 'Spend',
      placeHolders: {
        min: 'Min',
        max: 'Max',
      },
    },
  },
  order: {
    popup: {
      rejectOrder: {
        title: 'Reject Order',
        description:
          'Please provide a reason for rejecting this order.\nRejection reason will be shared with the guest.',
        actionBtn: 'REJECT ORDER',
        backBtn: 'BACK',
      },
      applyDiscount: {
        title: 'Apply Extra Discount',
        description:
          'This is an irrevocable action. Once discount is applied, it cannot be taken back.\nDiscount can be applied only once on an order.',
        actionBtn: 'APPLY',
        backBtn: 'CANCEL',
        additionalDiscountFieldLabel: 'Extra Discount',
        discountUnitDropDownPlaceholder: 'Select',
        discountTypeDropDownFieldLabel: 'Discount Type',
        discountTypeDropDownPlaceholder: 'Type or select from list',
        totalBillLabel: 'Total Bill',
        paidCashCardLabel: 'Paid (Cash Card)',
        paidLabel: 'Paid',
        additionalDiscountLabel: 'Extra Discount',
        refundAmountLabel: 'Refund Amount',
        pendingAmountLabel: 'Pending Amount',
        refundToCashCardText: `Refund will be initiated to guest’s Cash Card`,
        refundToSourceAccountText: `Refund will be initiated which will take 5-7 days to reflect in guest’s account`,
        refundToCCAndSourceText: `Refund will be initiated first to the guest's cash card and then to the guest's source account`,
        errorMessage: {
          invalidPercentageAmount:
            'Discount percent should be greater than 0 and less than or equal to 100',
          invalidAbsoluteAmount: 'Discount amount should be a valid amount greater than 0',
          discountAmountExceedsBill: 'Amount cannot be more than the bill',
          discountTypeEmpty: 'A discount type needs to be selected',
          formError: 'Please resolve the highlighted issues',
        },
        updateToastMessage: 'Discount applied',
      },
      outletDiscountAlreadyApplied: {
        message: 'Discount already applied.\nDiscount can be applied only once on an order.',
        actionBtn: 'OK',
      },
      removeCharge: {
        title: 'Remove Charge',
        description:
          'This is a irrevocable action. Once charges are removed, they cannot be applied again',
        actionBtn: 'REMOVE',
        backBtn: 'CANCEL',
        totalBillLabel: 'Total Bill',
        paidCashCardLabel: 'Paid (Cash Card)',
        paidLabel: 'Paid',
        refundAmountLabel: 'Refund Amount',
        pendingAmountLabel: 'Pending Amount',
        refundToCashCardText: `Refund will be initiated to guest’s Cash Card`,
        refundToSourceAccountText: `Refund will be initiated which will take 5-7 days to reflect in guest’s account`,
        refundToCCAndSourceText: `Refund will be initiated first to the guest's cash card and then to the guest's source account`,
        updateToastMessage: 'Additional charge removed',
        excessRemovedCharges: 'Cannot remove charges beyond total bill',
      },
      posSyncErrors: {
        title: 'POS Sync Errors',
        actionBtn: 'OK',
        unableToSyncErrorText: `We're unable to sync this order with POS.`,
        trimmedUnableToSyncErrorText: `Unable to sync this order with POS.`,
        internalErrorText: `We’ve encountered an internal error.`,
        externalErrorText: `We did not receive any response from POS for this order.`,
        punchManuallyText: 'Please enter this order manually in POS',
        unmappedItemsLabel: 'All data must be mapped to successfully sync orders with POS.',
        unmappedItemsListHeading: 'The following items are not mapped with POS:',
        unmappedTableSuffix: 'is not mapped with POS data.',
      },
      charges: {
        delivery: 'Delivery Charges',
        deliveryDiscount: 'Delivery Discount',
        tax: 'Tax',
      },
    },
  },
  account: {
    title: 'Account',
    accountColumnTitle: 'Account Details',
    accountInfoPanelTitle: 'Outlet Profile',
    accountInfoPanelSubTitle: 'Restaurant Name, Logo, Social Media Links',
    accountInfoSettings: {
      restaurantDetailsTitle: 'Outlet Details',
      restaurantNameLabel: 'Outlet Name',
      restaurantAddressLabel: 'Outlet Address',
      googleLocationLabel: 'Google Location',
      restaurantCodeLabel: 'Outlet Code',
      googleLocationPlaceholder: 'Location not provided',
      aboutOutletLable: 'About Outlet',
      instagramLabel: 'Instagram',
      facebookLabel: 'Facebook',
      changeLogoCTAText: 'Change Logo',
      userDetailsTitle: 'User Details',
      usernameLabel: 'Username',
      termsAndConditions: 'Terms & Conditions',
      privacyPolicy: 'Privacy Policy',
      termsConditionsDescription:
        'You accepted Fudr’s <a>{termsAndConditions}</a> and <a>{privacyPolicy}</a> on {acceptanceDate} ',
      popup: {
        changeLogo: {
          title: 'Logo',
          backBtn: 'BACK',
          actionBtn: 'UPDATE',
          secondaryActionBtn: 'UPLOAD NEW IMAGE',
          imagePlaceholderText: 'No image provided',
        },
      },
      updateToastMessage: {
        changeLogo: 'Restaurant logo updated',
      },
    },
    subscriptionPlanDetailsPanelTitle: 'Plan Details',
    subscriptionPlanDetailsPanelSubTitle: 'Details of the subscribed plan',
    subscriptionPlanDetailsSettings: {
      currentPlanLabel: 'Current Plan',
      pricingLabel: 'Pricing',
      validTillLabel: 'Valid Till',
      subscriptionPlanIdLabel: 'Subscription Plan Id',
      trialText: 'Trial',
      zeroPlanPriceText: 'Free',
      billedPrefix: 'billed',
      monthSuffix: 'per month',
      freePlanDurationText: 'Lifetime',
      subscribedUserGroupInfoCardTitle:
        'This subscription plan is effective on the following Outlets',
      planNamePrefix: 'Fudr',
      trialRemainingDaysPrefix: 'Free Trial ends',
      planRemainingDaysPrefix: 'Subscription plan ends',
      inSupportingText: 'in',
      daysSuffix: 'days',
      todayInfix: 'today',
      emptyResultInfo: 'Currently, you are not subscribed to any plan',
      subscribeCTA: 'SUBSCRIBE',
      upgradeCTA: 'UPGRADE',
      editPlanCTA: 'EDIT PLAN',
    },
  },
  guest: {
    chipType: {
      date: 'date',
      order: 'Order',
      spend: 'Spend',
    },
    filterAppliedText: 'Filter(s) applied',
    numberFilterLabel: {
      greaterThan: 'Greater than',
      smallerThan: 'Smaller than',
      between: 'Between',
    },
    guestFiltersPopup: {
      dateFilterlabel: {
        anyDate: 'Any Date',
        today: 'Today',
        thisWeek: 'This week',
        thisMonth: 'This month',
      },
      durationLabel: 'Last Order',
      orderCountLabel: 'Order Count',
      orderAmountLabel: 'Order Amount',
      errorMessage: 'Please resolve the highlighted issues',
      errorInfo: {
        invalidRange: 'Please provide a valid range',
        invalidInput: 'Please provide a valid input',
      },
    },
  },
  redeemCoupon: {
    title: 'Redeem Coupon',
    subTitle: 'Coupon Code',
    description: ' Enter coupon code displayed on guest’s mobile',
    placeHolder: {
      enterCouponCode: 'Enter Coupon Code',
      enterBillAmount: 'Enter Bill Amount',
    },
    CTA: {
      verify: 'VERIFY',
    },
    footerContent: {
      backBtn: 'CANCEL',
      actionBtn: 'REDEEM',
    },
    redeemSuccessFooterContent: {
      actionBtn: 'DONE',
    },
    couponDetails: {
      title: 'Coupon Details',
      label: {
        couponName: 'Coupon Name',
        couponDiscount: 'Coupon Discount',
        duration: 'Duration',
      },
    },
    errorInfo: {
      INVALID_METHOD_PARAMS: {
        title: 'Something went wrong',
        message:
          'Sorry we are unable to redeem your coupon. Seems something is missing from your end. Please try again',
      },
      NOT_FOUND: {
        title: 'Incorrect Coupon Code',
        message:
          'The coupon code you are trying to redeem is incorrect. Please try with different coupon code',
      },
      INVALID_BRAND: {
        title: 'Coupon not valid for the restaurant',
        message:
          'The coupon code you are trying to redeem is not valid for the restaurant. Please try with different coupon code',
      },
      DEAL_REDEEMED: {
        title: 'Coupon already redeemed',
        message: 'This coupon has already been redeemed',
      },
      UNAUTHORISED_OUTLET: {
        title: 'Coupon not valid for the outlet',
        message:
          'The coupon code you are trying to redeem is not valid for the outlet. Please try with the same on different brand outlet',
      },
      DEAL_EXPIRED: {
        title: 'Coupon already expired',
        message:
          'The coupon code you are trying to redeem is already expired. Please try with different coupon code',
      },
      LOW_AMOUNT: {
        title: 'Something went wrong',
        message: '',
      },
    },
  },
  redemptionDetails: {
    guestName: 'Guest Name',
    mobileNumber: 'Mobile no.',
    couponCode: 'Coupon Code',
    discount: 'Discount',
    billAmount: 'Bill Amount',
    date: 'Date',
  },
  integrations: {
    pos: {
      posIntegration: 'POS Integration',
      breadcrumb: 'POS',
      title: 'Menu Items',
      checkBoxLabel: 'Show only unmapped items',
      searchFieldPlaceholder: 'Search by item name',
      searchCTAText: 'SEARCH',
      tabLabel: {
        menuItemMapping: 'MENU ITEM MAPPING',
        addOnMapping: 'CUSTOMIZATION MAPPING',
        tableMapping: 'TABLE MAPPING',
      },
      tableHeader: {
        fudrData: 'Fudr Data',
        posData: 'POS Data',
      },
      posIntegrationProperties: {
        posName: 'POS Name',
        status: 'Status',
      },
      viewSyncLogsCTA: 'VIEW SYNC LOGS',
      syncLogs: {
        title: 'Sync Logs',
        report: {
          title: 'Logs',
          search: {
            placeHolder: 'Search by Order ID',
            CTA: 'SEARCH',
          },
          columns: {
            orderId: 'Order ID',
            time: 'Date & Time',
            status: 'Status',
          },
          tooltip: {
            failed: `We're unable to sync this order with POS`,
          },
          appliedFilterText: 'Filter(s) applied',
          successLabel: 'Synced',
          failedLabel: 'Sync failed',
          pendingLabel: 'Sync in progress',
          statusUnavailable: 'NA',
          filters: {
            addedDate: 'Sync Date',
            status: 'Status',
            placeHolders: {},
          },
        },
      },
      popup: {
        updatePOSMappings: {
          actionBtn: 'UPDATE',
          backBtn: 'BACK',
          fudrDataHeading: 'Fudr Data',
          posDataHeading: 'POS Data',
          mappingSuffix: 'Mapping',
          unmappedFudrItemsBannerTitleSuffixSingular: 'of Fudr data is unmapped',
          unmappedFudrItemsBannerTitleSuffixPlural: 'of Fudr data are unmapped',
          unmappedPOSItemsBannerTitleSuffixSingular: 'of POS data is unmapped',
          unmappedPOSItemsBannerTitleSuffixPlural: 'of POS data are unmapped',
          updateSuccessToast: 'Mappings updated',
          errorInfo: {
            DUPLICATE_IDS: {
              message: 'A mapping for this menu item already exists',
            },
          },
        },
      },
    },
  },
};

export const browserPermissionBanner = {
  sound: {
    ctaText: 'ENABLE SOUND',
    message: 'Sound has been disabled. Enable it to get updates for new orders',
    toastMessage: 'Sound enabled for now',
  },
  notifications: {
    ctaText: 'ENABLE NOTIFICATIONS & SOUND',
    message: 'Notifications and sound have been denied. Enable them to get updates for new orders.',
  },
};

export const restaurantInactiveBanner = {
  buttonText: 'Go Live !!!',
  message: 'Your restaurant is not live yet. Go live to start accepting orders digitally',
};

export const guestHistoryConfig = {
  noOfOrder: 'No. of Orders',
  totalAmount: 'Total Amount',
};

export const orderHistoryConfig = {
  amount: 'Amount',
};

export const guestOrderConfig = {
  amount: 'Amount',
};
